import { Component, inject, input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { COMMON_IMPORTS } from '../../common-imports';
import { AvDialogComponent } from '../av-dialog/av-dialog.component';
import { AvBoolCellComponent } from '../av-bool-cell/av-bool-cell.component';
import { AvCardDialogConfig, AvCardField } from '../../Interfaces/av-card.interface';

@Component({
  selector: 'av-card',
  standalone: true,
  imports: [COMMON_IMPORTS, AvBoolCellComponent],
  templateUrl: './av-card.component.html',
  styleUrls: ['./av-card.component.scss'],
})
export class AvCardComponent {
  private readonly dialogService = inject(MatDialog);
  private readonly translate = inject(TranslateService);

  cardTitle = input.required<string>();
  icon = input.required<string>();
  fields = input.required<AvCardField[]>();
  dialog = input<AvCardDialogConfig | null>(null);
  showMoreLabelKey = input<string>('shared.general.buttons.view_details');

  hasDialog(): boolean {
    return !!this.dialog()?.entries?.length;
  }

  buttonLabelKey(): string {
    return this.dialog()?.buttonLabelKey ?? this.showMoreLabelKey();
  }

  openDialog(): void {
    const dialog = this.dialog();
    if (!dialog?.entries?.length) return;
    const title = dialog.titleKey ? this.translate.instant(dialog.titleKey) : (dialog.title ?? '');

    this.dialogService.open(AvDialogComponent, {
      data: { title, entries: dialog.entries, type: 'alert' },
      panelClass: 'av-dialog',
    });
  }
}
